/**
 * Chooses the providers for one send without changing the user's saved
 * selection. Deep Research reports are followed up by Anthropic alone.
 */
export function followUpProviderIDs(
  selected: string[],
  enabledProviderIDs: string[],
  chatHasDeepResearch: boolean,
  isDeepResearchSend: boolean
): string[] {
  if (
    chatHasDeepResearch &&
    !isDeepResearchSend &&
    enabledProviderIDs.includes("anthropic")
  ) {
    return ["anthropic"];
  }
  return selected;
}
